export default __webpack_public_path__ + "static/media/bridge-flow-1.726a5214.png";